<template>
    <div class="app-tabs" id="tabs">
        <transition-group name="tabs-transition" tag="div" class="app-tabs__inner" v-for="route in routes" v-show="route.routeKey === currentRoute" :key="route.routeKey">
            <button :key="tab.stackId" @click="() => onSwitch(tab)" :class="['app-tabs__item', {'active': isActive(tab)}, { 'can-delete' : canDeleteTabs } ]" v-for="tab in route.appStateHistory" :id="tab.stackId">
                <div class="app-tabs__item__inner">
                    <span>{{ visibleStackItem(tab).title }}</span>
                    <svg @click="() => closeTab(tab)" version="1.1" class="app-tabs__close" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284
                                        c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414
                                        c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293
                                        s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"></path></svg>
                </div>
            </button>
        </transition-group>
    </div>
</template>

<script>
    import Ps from 'perfect-scrollbar';
    import Vue from 'vue';

    export default {
        name: 'app-tabs',
        props: ['appHistory', 'tools'],
        mounted() {
            Ps.initialize(document.getElementById('tabs'));
        },
        watch: {
            currentRoute() {
                Ps.update(document.getElementById('tabs'));
            },
        },
        computed: {
            routes() {
                const routes = this.tools.routes;
                return Object.keys(routes).map(key => Object.assign(routes[key], { routeKey: key }));
            },
            currentRoute() {
                return this.tools.currentRouteKey;
            },
            tabs() {
                return this.appHistory;
            },
            currentStackId() {
                return this.tools.currentApp.stackId;
            },
            canDeleteTabs() {
                return this.tabs.length > 1;
            }
        },
        methods: {
            closeTab(tab) {
                const tabs = this.tabs;
                const index = tabs.findIndex(t => t.stackId === tab.stackId);

                // Go to prev tab
                const nextTab = typeof tabs[index + 1] !== 'undefined' ? tabs[index + 1] : tabs[index - 1];
                this.onSwitch(nextTab);

                // Delete tab
                Vue.delete(tabs, index);
            },
            onSwitch(tab) {
                if (!this.isActive(tab) &&  this.tabs.findIndex(t => t.stackId === tab.stackId) >= 0) {
                    this.tools.actions.switchContext(tab);
                }
            },
            isActive(tab) {
                return tab.stackId === this.currentStackId;
            },
            visibleStackItem(tab) {
                const { tools } = this;
                // If preview is the current; show content from current
                if (tab.stackId === tools.currentApp.stackId) {
                    return this.tools.currentApp.appState[this.tools.currentApp.appState.length - 1];
                }
                return tab.stack[tab.stack.length - 1];
            },
            resizeTabs() {
                const tabs = this.tabs;
                const container = document.getElementById('tabs');
                const containerInner = container.querySelector('.app-tabs__inner')
                const containerWidth = container.clientWidth;
                setTimeout(() => {
                    // if (tabs.length && containerInner.clientWidth > container.clientWidth) {
                    if (tabs.length) {
                        const commonWidth = Math.floor(container.clientWidth / tabs.length);
                        console.log('container', container.clientWidth);
                        tabs.forEach((tab) => {
                            const el = document.getElementById(tab.stackId);
                            const innerWidth = el.querySelector('.app-tabs__item__inner').clientWidth;
                            if (innerWidth > commonWidth) {
                                el.style.width = commonWidth + 'px';
                            } else {
                                el.style.width = innerWidth + 'px';
                            }
                            // console.log(innerWidth);
                            // console.dir(el);
                        });
                    }
                }, 50);
            },
        },
    };
</script>
<style>
    .app-tabs {
        margin-bottom: -1px;
        width: 100%;
        display: flex;
        align-self: flex-end;
        overflow: hidden;
    }

    .app-tabs__inner {
        display: flex;
    }

    .app-tabs__item span {
        padding: 0 8px;
    }

    .app-tabs__item {
        border: 1px solid rgba(0, 0, 0, .15);
        border-right: 0;
        position: relative;
        transition: opacity .2s;
        overflow: hidden;
        padding: 0;
        float: left;
        transition: width .7s;
    }

    .app-tabs__item__inner {
        padding: 8px 14px 8px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }

    .app-tabs__close:hover {
        background-color: #e74c3c;
        fill: #FFF;
        opacity: .6;
    }
    .app-tabs__close {
        position: absolute;
        right: 3px;
        width: 14px;
        fill: rgba(0, 0, 0, .3);
        border-radius: 999px;
        top: 50%;
        margin-top: -6px;
    }

    .app-tabs .app-tabs__item:first-child .app-tabs__close {
        display: none;
    }

    .app-tabs .app-tabs__item:first-child .app-tabs__item__inner {
        padding: 8px 0;
    }

    .app-tabs__item:not(.active):hover {
        opacity: .65;
        transition: opacity .2s;
    }

    .app-tabs .app-tabs__item:last-child {
        border-right: 1px solid rgba(0, 0, 0, .15);
    }

    .app-tabs__item.active {
        /*border-bottom: 1px solid transparent;*/
        border-top: 0;
        background: #FFF;
    }

    .app-tabs__item.active:after {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        height: 4px;
        background-color: #2b75bb;
    }


    /**
     * Transition
     */

        .tabs-transition-enter-to,
        .tabs-transition-leave {
            opacity:1;
            transition: all .4s;
        }
        .tabs-transition-enter,
        .tabs-transition-leave-to {
            transform: translateX(-10px);
            opacity:0;
            transition:all .2s;
        }
</style>



// WEBPACK FOOTER //
// index.vue?14df714c